import { reactive, toRefs, computed, watch } from '@vue/composition-api';
import { numberFormat } from '../helpers/utils';

const useSelectBranch = (props, context, options = {}) => {
	const { defaultState } = options;

	const event = reactive({
		selectedIds: defaultState.selectedValues || [],
		selectedAll: props.checkAll !== undefined
			? props.checkAll
			: false,
		selectedCount: defaultState.selectedValues !== undefined
			? defaultState.selectedValues.length
			: 0,
		selectedCountFriendly: computed(() => numberFormat(event.selectedCount)),
		// temporary branches info including: id, itec id
		temp: [],
	});

	const handleSubmit = (selectedBranchIds = []) => {
		context.emit('onDone', selectedBranchIds);
	};

	const handleFetch = (data = []) => {
		data.forEach((item) => event.temp.push(item));
	};

	const handlePropValues = (newValues) => {
		event.selectedIds = newValues;
		event.selectedCount = newValues.length;
	};

	const handlePropCheckAll = (newCheckAll) => {
		event.selectedAll = newCheckAll;
	};

	const handlePropTemporary = (newTemp = []) => {
		newTemp.forEach((item) => event.temp.push(item));
	};

	watch(() => props.values, handlePropValues);
	watch(() => props.branchIds, handlePropValues);

	watch(() => props.checkAll, handlePropCheckAll);

	watch(() => props.temporary, handlePropTemporary);
	watch(() => props.temporaryBranches, handlePropTemporary);

	return {
		...toRefs(event),
		handleSubmit,
		handleFetch,
	};
};

export default useSelectBranch;